module.exports = __webpack_public_path__ + "static/img/test-1-image@3x.15d9a24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduction/test-1-image@3x.png
// module id = Vmq5
// module chunks = 6